export const sessionId = `s-${Date.now()}-${Math.round(Math.random() * Math.pow(10, 10))}`;
